import React from 'react';
import { Link } from 'react-router-dom';
import { useLocalizedPath } from '../utils/localizedPath.js';

// Drop-in replacement for react-router's <Link> that prefixes `to`
// with the current language (no prefix for the default language).
const LocalizedLink = ({ to, ...props }) => {
  const { localize } = useLocalizedPath();
  return <Link to={localize(to)} {...props} />;
};

export default LocalizedLink;
